import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../abstract/api.service';
import { ZohoDroneSyncResult } from '../response-models/zoho-drone-sync-result.model';
import { isRecord } from '../utils/is-record';
import { nullableString } from '../utils/wire-value-utils';

const SYNC_OPERATIONS = ['create', 'update', 'skip'] as const;

/**
 * Pushes one ADN drone to Zoho FSM: POST /admin/zoho/sync/drones/:id (hub `admin-zoho-controller.ts`). An action
 * with no entity model, so this is an api-service. The Zoho integration is slated for removal; keep this minimal.
 */
@Injectable({ providedIn: 'root' })
export class ZohoSyncService extends ApiService {
  constructor() {
    super('admin/zoho/sync/drones');
  }

  syncDrone(droneId: string): Observable<ZohoDroneSyncResult> {
    return this.request('POST', { id: droneId }, toSyncResult, {});
  }
}

function toSyncResult(data: unknown): ZohoDroneSyncResult {
  const source = isRecord(data) ? data : {};
  const operation = SYNC_OPERATIONS.find(op => op === source['operation']) ?? null;
  return { success: source['success'] === true, operation, error: nullableString(source['error']) ?? null };
}
